import React, { useState } from 'react'
import { SpinnerWrapper } from './styles';
import { Spinner } from 'ui'

const Image = ({ src, alt }) => {

  const [isLoading, setIsLoading] = useState(true)

  const handleLoad = () => setIsLoading(false)

  return (
    <div>
      {isLoading && (
        <SpinnerWrapper>
          <Spinner />
        </SpinnerWrapper>
      )}

      <img
        src={src}
        alt={alt}
        loading='lazy'
        onLoad={handleLoad}
        style={ isLoading
          ? { position: 'absolute', top: '0' }
          : {}
        }
      />
    </div>
  )
};

export default Image